import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Views from './views';

import { clearBrowserCache } from 'utils';

function App() {
    const theme = useSelector((state) => state.darkMode);

    useEffect(() => {
        const colorTheme = theme === 'dark' ? 'light' : 'dark';
        const root = window.document.documentElement;
        root.classList.remove(colorTheme);
        root.classList.add(theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    useEffect(() => {
        clearBrowserCache();
    }, []);

    return <Views />;
}

export default App;
